import React, { useEffect, useState } from 'react'
import { Calendar } from 'antd';
import "../../Assets/Css/Leave.scss"
import Select from 'react-select';
import { customStyle } from '../../Components/Style';
import ListIcon from "../../Assets/Images/Holiday/list"
import Calendaricon from "../../Assets/Images/Holiday/calendar"
import { useLocation, useNavigate } from 'react-router-dom';

const Employees = [
     { value: "Meet", label: "Meet" },
     { value: "Kuntesh", label: "Kuntesh" },
     { value: "Raj", label: "Raj" },
     { value: "Harsh", label: "Harsh" },
     { value: "Nand", label: "Nand" },
];

const LeaveType = [
     { value: "Earned", label: "Earned" },
     { value: "Casual", label: "Casual" },
     { value: "Unpaid", label: "Unpaid" },
];

const statusOptions = [
     { value: "Approved", label: "Approved" },
     { value: "Rejected", label: "Rejected" },
     { value: "Pending", label: "Pending" },
];

const EmployeeOnleave = [
     { employee: "Meet", date: "2024-09-20" },
     { employee: "Kuntesh", date: "2024-09-21" },
     { employee: "Raj", date: "2024-09-22" },
];

const LeaveCalendar = () => {
     const [selectFilters, setSelectedFilters] = useState({
          date: "",
          status: [],
          leaveType: [],
          employee: []
     });
     const [activeButton, setActiveButton] = useState("");

     const navigate = useNavigate()
     const location = useLocation();

     useEffect(() => {
          const path = location.pathname.split('/')[2];
          setActiveButton(path)
     }, []);

     const handleClick = (buttonId, route) => {
          setActiveButton(buttonId);
          navigate(route);
     };

     const dateCellRender = (value) => {
          const date = value.format('YYYY-MM-DD');
          const holiday = EmployeeOnleave?.find(holiday => holiday.date === date);

          if (holiday) {
               return (
                    <>
                         <div className="leave-container">
                              <span className="leave-employe">{holiday.employee}</span>
                         </div>
                         <div className="leave-container">
                              <span className="leave-employe">{holiday.employee}</span>
                         </div>
                         <div className="leave-container">
                              <span className="leave-employe">{holiday.employee}</span>
                         </div>
                         <div className="leave-container">
                              <span className="leave-employe">{holiday.employee}</span>
                         </div>
                    </>
               );
          }

          return null;
     };

     const onPanelChange = (value, mode) => {
          console.log(value.format('YYYY-MM-DD'), mode);
     };

     const handleAddLeave = () => {
          navigate('/leave/add')
     }

     const hadleList = () => {
          navigate('/leave')
     }

     return (
               <div className='calendar-container-part'>
                    <div className='calendar-header'>
                         <p className='calendar-title'>Calendar</p>
                    </div>

                    <div className='calendar-filter-part'>
                         <div className='row'>
                              <div className="col-lg-3 col-md-6">
                                   <div className="input-group">
                                        <Select
                                             value={selectFilters.employee}
                                             onChange={(data) =>
                                                  setSelectedFilters({ ...selectFilters, employee: data })
                                             }
                                             options={Employees}
                                             placeholder={"Member"}
                                             styles={customStyle}
                                             theme={(theme) => ({
                                                  ...theme,
                                                  colors: {
                                                       ...theme.colors,
                                                       primary25: "#5757fe",
                                                       primary: "#5757fe",
                                                  },
                                             })}
                                        />
                                   </div>
                              </div>

                              <div className="col-lg-3 col-md-6">
                                   <div className="input-group">
                                        <Select
                                             value={selectFilters.leaveType}
                                             onChange={(data) =>
                                                  setSelectedFilters({ ...selectFilters, leaveType: data })
                                             }
                                             options={LeaveType}
                                             placeholder={"Leave Type"}
                                             styles={customStyle}
                                             theme={(theme) => ({
                                                  ...theme,
                                                  colors: {
                                                       ...theme.colors,
                                                       primary25: "#5757fe",
                                                       primary: "#5757fe",
                                                  },
                                             })}
                                        />
                                   </div>
                              </div>

                              <div className="col-lg-3 col-md-6">
                                   <div className="input-group">
                                        <Select
                                             value={selectFilters.status}
                                             onChange={(data) =>
                                                  setSelectedFilters({ ...selectFilters, status: data })
                                             }
                                             options={statusOptions}
                                             placeholder={"Status"}
                                             styles={customStyle}
                                             theme={(theme) => ({
                                                  ...theme,
                                                  colors: {
                                                       ...theme.colors,
                                                       primary25: "#5757fe",
                                                       primary: "#5757fe",
                                                  },
                                             })}
                                        />
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className='action-part'>
                         <div className="edit-btn">
                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={handleAddLeave}
                              >
                                   Add Leave
                              </button>

                              <button
                                   type="submit"
                                   className="custom-btn"
                              // onClick={hadleBack}
                              >
                                   Export
                              </button>
                         </div>

                         <div className="navigation_btn">
                              <button
                                   className={`btn1 ${activeButton === "leave" ? "active" : ""}`}
                                   onClick={() => handleClick("leave", "/leave")}
                              >
                                   <ListIcon color={activeButton === "leave" ? "white" : "black"} bgColor={activeButton === "leave" ? "black" : "white"} />
                              </button>
                              <button
                                   className={`btn1 ${activeButton === "calendar" ? "active" : ""}`}
                                   onClick={() => handleClick("calendar", "/leave/calendar")}
                              >
                                   <Calendaricon color={activeButton === "calendar" ? "white" : "black"} bgColor={activeButton === "calendar" ? "black" : "white"} />
                              </button>
                         </div>

                    </div>

                    <div className='calendar-part'>
                         <Calendar
                              mode="month"
                              dateCellRender={dateCellRender}
                              onPanelChange={onPanelChange} />
                    </div>
               </div>

     )
}

export default LeaveCalendar
